import React, { useState } from "react";
import Header from "../components/Navbar/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Navbar/Footer";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getLocalStorageData } from "../utils/helpers/helpers";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { post } from "../utils/helpers/http";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import icons

const Changepassword = () => {
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [disableChangePassword, setDisabledChangePassword] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);

  const validationSchema = Yup.object().shape({
    currentPassword: Yup.string().required("Current Password is required"),
    newPassword: Yup.string()
      .required("New Password is required")
      .min(8, "Password must be at least 8 characters")
      .max(12, "Password must be at most 12 characters")
      .matches(
        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[a-zA-Z]).{8,}$/,
        "Password must contain at least 1 capital letter, 1 lower letter, 1 special character, and 1 numeric character"
      ),
    confirmNewPassword: Yup.string()
      .required("Confirm New Password is required")
      .oneOf([Yup.ref("newPassword"), null], "Passwords must match"),
  });

  const handleChangePassword = async (values) => {
    const { currentPassword, newPassword, confirmNewPassword } = values;
    if (currentPassword === newPassword && newPassword === confirmNewPassword) {
      toast.error('Current and new password should not be the same!');
      return;
    }

    try {
      const accessToken = getLocalStorageData("accessToken");
      console.log("accessToken:", accessToken);
      const authorizationToken = getLocalStorageData("authorizationToken")
      console.log("authorizationToken:", authorizationToken)
      let body = {
        oldPassword: values.currentPassword.trim(),
        password: values.newPassword.trim(),
        confirmPassword: values.confirmNewPassword.trim(),
      }
      const response = await post('/Account/ChangePassword', body);
     
      if (response.status === 200) {
        setSuccess(true);
        setError(null);
        toast.success('Password updated successfully!');
        setTimeout(() => {
          window.location.href = "/";
        }, 2000);
      }
      else if (response.status === 202) {
        toast.warning(response.data.message);
      }
      else {
        toast.error('Incorrect Old Password');
      }
    } catch (error) {
      toast.error('An error occurred. Please try again later.');
    }
  };

  return (
    <>
      <Header />
      <div id="wrapper">
        <Navbar />
        <div id="content-wrapper">
          <div className="content_minArea">
            <div className="container-fluid">
              <div className="page-header">
                <div className="lefth">
                  <h1 className="page-title">Change Password</h1>
                </div>
              </div>
              <div className="page-content">
                <Formik
                  initialValues={{
                    currentPassword: "",
                    newPassword: "",
                    confirmNewPassword: "",
                  }}
                  validationSchema={validationSchema}
                  validateOnChange={true}
                  validateOnBlur={true}
                  onSubmit={handleChangePassword}
                >
                  {({ errors, touched, values }) => (
                    <Form>
                      <div className="row">
                        <div className="col-lg-3 col-md-6 col-sm-12">
                          <div className="form-group mb-3">
                            <label className="form-label">
                              Current Password <span style={{ color: "red" }}>*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                type={showCurrentPassword ? "text" : "password"}
                                name="currentPassword"
                                className="form-control"
                                placeholder="*******"
                              />
                              {values.currentPassword && (
                                <button
                                  type="button"
                                  onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                                  style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    border: "none",
                                    background: "transparent",
                                    padding: 0,
                                  }}
                                >
                                  {showCurrentPassword ? <FaEyeSlash /> : <FaEye />}
                                </button>
                              )}
                            </div>
                            {errors.currentPassword && touched.currentPassword && (
                              <div className="text-danger">{errors.currentPassword}</div>
                            )}
                          </div>

                          <div className="form-group mb-3">
                            <label className="form-label">
                              New Password <span style={{ color: "red" }}>*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                type={showNewPassword ? "text" : "password"}
                                name="newPassword"
                                className="form-control"
                                placeholder="*******"
                              />
                              {values.newPassword && (
                                <button
                                  type="button"
                                  onClick={() => setShowNewPassword(!showNewPassword)}
                                  style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    border: "none",
                                    background: "transparent",
                                    padding: 0,
                                  }}
                                >
                                  {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                                </button>
                              )}
                            </div>
                            {errors.newPassword && touched.newPassword && (
                              <div className="text-danger">{errors.newPassword}</div>
                            )}
                          </div>

                          <div className="form-group mb-3">
                            <label className="form-label">
                              Confirm New Password <span style={{ color: "red" }}>*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                type={showConfirmNewPassword ? "text" : "password"}
                                name="confirmNewPassword"
                                className="form-control"
                                placeholder="*******"
                              />
                              {values.confirmNewPassword && (
                                <button
                                  type="button"
                                  onClick={() => setShowConfirmNewPassword(!showConfirmNewPassword)}
                                  style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    border: "none",
                                    background: "transparent",
                                    padding: 0,
                                  }}
                                >
                                  {showConfirmNewPassword ? <FaEyeSlash /> : <FaEye />}
                                </button>
                              )}
                            </div>
                            {errors.confirmNewPassword && touched.confirmNewPassword && (
                              <div className="text-danger">{errors.confirmNewPassword}</div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="form-group mt-4 mb-0">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={disableChangePassword}
                        >
                          Change Password
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>

                {error && (
                  <div className="alert alert-danger mt-3" role="alert">
                    {error}
                  </div>
                )}
              </div>
            </div>
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              closeOnClick
              pauseOnHover
              draggable
              onOpen={() => {
                setDisabledChangePassword(true);
                setTimeout(() => {
                  setDisabledChangePassword(false);
                }, 5000);
              }} />
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Changepassword;
